import {Button, Card, Empty} from "antd";

export const CVLists = ({cvList}) => {

    return (
        <div className={"p-4 w-full"}>
            {!cvList.length ? (
                <div className={"space-y-8 justify-center items-center flex"}>
                    <Button className={"text-gray-700"} onClick={() => console.log("NO NO NO")}>
                        Tạo CV
                    </Button>
                    <Empty description={"Không có dữ liệu"}/>
                </div>
            ) : (
                <div className={"grid grid-cols-1 gap-4 mt-4"}>
                    {cvList.map((cv, index) => (
                        <Card key={index} className={"rounded-lg"}>
                            <h3 className={"text-lg font-semibold text-cyan-800"}>{cv.wantedJob.title}</h3>
                            <p className={"text-cyan-800 text-md"}>Nơi muốn làm việc: {cv.wantedJob.workPlace}</p>
                            <p className={"text-cyan-800 text-md"}>Hình thức làm việc: {cv.wantedJob.jobType}</p>
                            <p className={"text-cyan-800 text-md"}>Địa điểm làm việc: {cv.wantedJob.workLocation}</p>
                            <p className={"text-cyan-800 text-md"}>Lĩnh vực: {cv.wantedJob.field}</p>
                            <p className={"text-cyan-800 text-md"}>Vị trí: {cv.wantedJob.position}</p>
                            <p className={"text-cyan-800 text-md"}>Mức lương: {cv.wantedJob.salary}</p>
                            <p className={"text-cyan-800 text-md"}>Mục tiêu nghề
                                nghiệp: {cv.wantedJob.careerObjective}</p>
                            <p className={"text-cyan-800 text-md"}>Kinh nghiệm: {cv.experiences.length} năm</p>
                            <p className={"text-cyan-800 text-md"}>Kỹ năng: {cv.skills.length} kỹ năng</p>
                        </Card>
                    ))}
                </div>
            )}
        </div>
    )
}